import { getItemMaker } from "./tools";

const i = getItemMaker("pants");
export const pants = [
  i("Torn Jeans"),
  i("Give Up On Life Pants", "EquipmentPants10"),
  i("Copper Platelegs", "EquipmentPants2"),
  i("Iron Platelegs", "EquipmentPants3"),
  i("Dirty Coal Miner Baggy Soot Pants", "EquipmentPants18"),
  i("Bleached Designer Wode Patch Pants", "EquipmentPants15"),
  i("Fishing Overalls", "EquipmentPants22"),
  i("Bandito Pantaloon", "EquipmentPants23"),
  i("Gold Platelegs", "EquipmentPants4"),
  i("Adam's Leaf", "EquipmentPants16"),
  i("Amarok Hinds", "EquipmentPants17"),
  i("Platinum Shins", "EquipmentPants5"),
  i("Dementia Shins", "EquipmentPants6"),
  i("Efaunt Hipilium", "EquipmentPants20"),
  i("Trimmed Rune Platelegs"),
  i("Void Imperium Shardshins", "EquipmentPants21"),
  i("Chizoar Scaled Leggings"),
  i("Lustre Scales"),
  i("Diabolical Trimed Leg Guards"),
  i("Twisted Scales"),
  i("Magma Core Battleskirt"),
  i("Spiked Leggings of the Divine"),
  i("Marbiglass Legplates"),
  i("Tatters of the Gods"),
];
